import LandingHeaderSection from "../landingPage/landingHeaderSection";
import LandingFooterSection from "../landingPage/landingFooterSection";
import {
  LoginPageFill,
  LoginPageRoot,
  LoginPageSection,
} from "../landingPage/landingPage.styles";
import { WebSunsetNotice } from "./webSunsetNotice";

const LoginPage = () => {
  return (
    <LoginPageRoot>
      <LandingHeaderSection />
      <LoginPageFill>
        <LoginPageSection $fill>
          <WebSunsetNotice />
        </LoginPageSection>
      </LoginPageFill>
      <LandingFooterSection />
    </LoginPageRoot>
  );
};

export default LoginPage;
